module.exports = __webpack_public_path__ + "img/高新技术企业.4d4b720c.png";